// extracted by mini-css-extract-plugin
module.exports = {"completeContainer":"Complete_completeContainer__2MUzZ","title":"Complete_title__2Zecw","extraCopy":"Complete_extraCopy__3uSAO","icon":"Complete_icon__26fVg"};